module.exports = __webpack_public_path__ + "static/img/Pin_Icon.35204055.svg";